import { render, staticRenderFns } from "./EmailSectionEntry.vue?vue&type=template&id=0c07a057&scoped=true"
import script from "./EmailSectionEntry.vue?vue&type=script&lang=js"
export * from "./EmailSectionEntry.vue?vue&type=script&lang=js"
import style0 from "./EmailSectionEntry.vue?vue&type=style&index=0&id=0c07a057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07a057",
  null
  
)

export default component.exports